import { render, staticRenderFns } from "./table-badge.vue?vue&type=template&id=6ee5a2c3"
import script from "./table-badge.vue?vue&type=script&lang=ts"
export * from "./table-badge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee5a2c3')) {
      api.createRecord('6ee5a2c3', component.options)
    } else {
      api.reload('6ee5a2c3', component.options)
    }
    module.hot.accept("./table-badge.vue?vue&type=template&id=6ee5a2c3", function () {
      api.rerender('6ee5a2c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-badge.vue"
export default component.exports